export enum EVerticalNames {
  OPOS = 'OPOS',
  UNI = 'UNI',
  WKC = 'WKC',
  FP = 'FP'
}

export enum ESubVerticalNames {
  PCE = 'PCE',
  EDU = 'EDU',
  ADMIN = 'ADMIN'
}

export const ALL_VERTICALS = Object.values(EVerticalNames);
